//授课-课中获取小组信息
export const SK_GROUP_LIST = 'sk_group_list'
//授课-课中获取小组中学生信息
export const SK_GROUP_STU_LIST = 'sk_group_stu_list'
//授课课堂得分增加
export const SK_SCORE_STU = 'sk_score_stu'
//授课课堂得分选项列表
export const SK_SCORE_OPT_LIST = 'sk_score_opt_list'
//授课-课中获取全班中学生信息
export const SK_CLASS_STU_LIST = 'sk_class_stu_list'
//授课-课中获取目录列表
export const SK_CATALOG_LIST = 'sk_catalog_list'
//授课-课中活动记录
export const SK_ACTIVITY_RECORD_ADD = 'sk_activity_record_add'






// WEBPACK FOOTER //
// ./src/store/give-course/other/type.js